import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden tech-pattern" data-id="element-129">
      {/* Background glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-cyan-500/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-130"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-131">
        <div className="flex flex-col items-center text-center" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-6" data-id="element-133">
            <span className="text-cyan-400 text-sm font-semibold" data-id="element-134">
              🤖 SABER-DIGITAL™
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-display font-bold leading-tight mb-6" data-id="element-135">
            Todo tu dominio de la IA.
            <br data-id="element-136" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-500 glow-text-cyan" data-id="element-137">
              Las 3 más poderosas.
            </span>
            <br data-id="element-138" />
            Listo. Desde hoy.
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="mb-8 space-y-2" data-id="element-139">
            <h2 className="text-xl md:text-2xl font-bold text-white/90" data-id="element-140">
              MEGA PACK INTELIGENCIA ARTIFICIAL
            </h2>
            <p className="text-lg text-cyan-400 font-medium" data-id="element-141">
              3 Tomos + 3 Bonos + Workflow Total
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="max-w-2xl text-lg text-gray-400 mb-10 leading-relaxed" data-id="element-142">
            Dominá ChatGPT, DeepSeek y Claude con prompts reales, flujos de
            trabajo y sistemas listos para usar. Desde cero hasta nivel
            profesional. Sin improvisar. Sin pagar suscripciones.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col items-center w-full max-w-md" data-id="element-143">
            <button onClick={scrollToPricing} className="w-full bg-cyan-400 hover:bg-cyan-300 text-dark font-bold text-lg py-4 px-8 rounded-full flex items-center justify-center gap-2 transition-all transform hover:scale-105 animate-pulse-glow mb-4" data-id="element-144">
              QUIERO MI MEGA PACK IA AHORA <ArrowRight className="w-5 h-5" data-id="element-145" />
            </button>

            <div className="flex items-center justify-center gap-4 text-xs text-gray-500" data-id="element-146">
              <div className="flex items-center gap-1" data-id="element-147">
                <ShieldCheck className="w-4 h-4" data-id="element-148" /> Pago seguro
              </div>
              <span data-id="element-149">|</span>
              <div className="flex items-center gap-1" data-id="element-150">
                <CreditCard className="w-4 h-4" data-id="element-151" /> Tarjeta / Transferencia /
                PayPal / Mercado Pago
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.6
        }} className="mt-16 w-full max-w-5xl relative" data-id="element-152">
            <div className="absolute inset-0 bg-gradient-to-t from-dark via-transparent to-transparent z-10 pointer-events-none h-full" data-id="element-153"></div>
            <img src="https://cdn.magicpatterns.com/uploads/adWMkNyZ1MEUpTVaWv7Vkq/mock_up5.png" alt="Mega Pack IA Mockup" className="w-full h-auto object-cover rounded-xl shadow-2xl animate-float" data-id="element-154" />
          </motion.div>
        </div>
      </div>
    </section>;
}